var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ThemeFamilies } from '../../theme/families';
import ModalContainer from './ModalContainer';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import styled from 'styled-components';
import { changeOpacityOfColor } from '../../utils/cssUtils';
export var SharedPropsContext = React.createContext({ themeFamily: ThemeFamilies.PRIMARY });
export { ModalContainer, ModalContent, ModalFooter, ModalHeader };
var Modal = function (_a) {
    var staticSize = _a.staticSize, name = _a.name, className = _a.className, children = _a.children, themeFamily = _a.themeFamily, title = _a.title, subTitle = _a.subTitle, primaryButtonProps = _a.primaryButtonProps, secondaryButtonProps = _a.secondaryButtonProps, onCloseClick = _a.onCloseClick, isBlurredBackground = _a.isBlurredBackground;
    return (_jsxs(Container, { children: [_jsx(BackgroundOverlay, { isBlurred: isBlurredBackground, themeFamily: themeFamily }, void 0),
            _jsx(FlexWrapper, { children: _jsx(SharedPropsContext.Provider, __assign({ value: { staticSize: staticSize, name: name, themeFamily: themeFamily } }, { children: _jsxs(ModalContainer, __assign({ onCloseClick: onCloseClick, name: name, className: className, staticSize: staticSize }, { children: [_jsx(ModalHeader, { name: name, subTitle: subTitle, title: title }, void 0), children, (primaryButtonProps || secondaryButtonProps) && (_jsx(ModalFooter, { primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, staticSize: staticSize, name: name }, void 0))] }), void 0) }), void 0) }, void 0)] }, void 0));
};
Modal.defaultProps = {
    themeFamily: ThemeFamilies.PRIMARY,
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 6;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n"], ["\n  z-index: 6;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n"])));
var FlexWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var BackgroundOverlay = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  backdrop-filter: ", ";\n"], ["\n  position: fixed;\n  background-color: ",
    ";\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  backdrop-filter: ", ";\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return changeOpacityOfColor(theme.families.modal[themeFamily].selectedText, 0.6);
}, function (_a) {
    var isBlurred = _a.isBlurred;
    return isBlurred && 'blur(4px)';
});
export default Modal;
var templateObject_1, templateObject_2, templateObject_3;
